import { render, staticRenderFns } from "./addSalesman.vue?vue&type=template&id=450a1a12&scoped=true&"
import script from "./addSalesman.vue?vue&type=script&lang=js&"
export * from "./addSalesman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a1a12",
  null
  
)

export default component.exports